module.exports = __webpack_public_path__ + "media/img/features/password-generator-thumb-f6b3cab68b7ea2b78a521e406196d349.png";